<div class="PGBookedProduct">
    @if(productData) {
        <div>
            @if (selectedAvailability != null || status != null) {
                <div class="PGBookedProduct-ProductHeader border rounded bg-white">
                    <div class="d-flex justify-content-between align-items-center p-3">
                        @if (selectedAvailability != null) {
                            @if (selectedAvailability.from != null && selectedAvailability.to != null) {
                                <div>
                                    <i class="fa-regular fa-calendar me-2"></i> {{formatSelectedAvailabilityDateFrom()}} - {{formatSelectedAvailabilityDateTo()}}
                                </div>
                            }
                            @if (selectedAvailability.from == null && selectedAvailability.to == null) {
                                <div>
                                    <i class="fa-regular fa-calendar me-2"></i>{{formatSelectedAvailabilityDate()}}
                                    <i class="fa-regular fa-clock ms-3 me-2"></i>{{formatSelectedAvailabilityTime()}}
                                </div>
                            }
                        }
                        @if (!isCumulativeBooking() && status != null) {
                            <div>
                                <div class="badge bg-{{getStatusColor()}}">{{ 'pg-booking-product.status-' + status | locTranslate}}</div>
                            </div>
                        }
                    </div>
                </div>
            }
            @if (productData != null) {
                @if(isCumulativeBooking()) {
                    <div class="PGBookedProduct-CumulativeOverlay">
                        <span class="text-muted">
                            <i class="fa-regular fa-tag"></i>
                            <span class="ms-2">{{ 'pg-booking-product.cumulative-group' | locTranslate }}</span>
                        </span>
                    </div>
                }

                <app-pg-product-card [compact]="compact == true" [productData]="productData" [supplierData]="supplierData"></app-pg-product-card>
            }
        </div>
        <div pdfgen="block" class="px-3 pt-3 rounded border PGBookedProduct-Content bg-white">
            <span [hidden]="compact == true">
                @if (selectedLanguage != null) {
                    <div class="PGBookedProduct-Section">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-selected-' + (productData.type || 'experience') + '-language' | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3" pdfgen="line">
                            {{getLanguageLabel()}}
                        </div>
                    </div>
                }
    
                @if (selectedAvailability != null) {
                    <div class="PGBookedProduct-Section">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-date' | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected PGBookedProduct-Selected--BFloatDeep border-bottom pb-3 mb-3">
                            <div pdfgen="line">
                                @if (selectedAvailability.from != null && selectedAvailability.to != null) {
                                    <div [innerHTML]="'pg-booking-product.date-day-from' | locTranslate:'day':formatSelectedAvailabilityDateFrom()"></div>
                                    <div [innerHTML]="'pg-booking-product.date-day-to' | locTranslate:'day':formatSelectedAvailabilityDateTo()"></div>
                                }
                                @if (selectedAvailability.from == null && selectedAvailability.to == null) {
                                    <div [innerHTML]="'pg-booking-product.date-day' | locTranslate:'day':formatSelectedAvailabilityDate()"></div>
                                    @if (selectedAvailability.slotDuration != null) {
                                        <div [innerHTML]="'pg-booking-product.date-time' | locTranslate:'time':formatSelectedAvailabilityTime()"></div>
                                    }
                                    @if (selectedAvailability.slotDuration == null) {
                                        @if (selectedAvailability.begin != null || selectedAvailability.end != null) {
                                            <div [innerHTML]="'pg-booking-product.date-time-from' | locTranslate:'time':formatSelectedAvailabilityLapseFrom()"></div>
                                            <div [innerHTML]="'pg-booking-product.date-time-to' | locTranslate:'time':formatSelectedAvailabilityLapseTo()"></div>
                                            @if (selectedAvailability.timezone != currentTimezone) {
                                                <div [innerHTML]="'pg-booking-product.date-timezone' | locTranslate:'tz':selectedAvailability.timezone"></div>
                                            }
                                        }
                                    }
                                }
                                @if (selectedAvailability.info) {
                                    <div>
                                        <i class="fa-regular fa-circle-info me-2 text-muted"></i>
                                        <span>{{ formatAvailabilityInfo(selectedAvailability.info) }}</span>
                                    </div>
                                }
                            </div>
                            @if (showNotCancelableWarning()) {
                                <div class="alert alert-warning mt-3 mb-0">
                                    <h5>{{ 'pg-booking-product.not-cancelable-title' | locTranslate }}</h5>
                                    <div>{{ 'pg-booking-product.not-cancelable-text' | locTranslate }}</div>
                                </div>
                            }
                        </div>
                    </div>
                    @if (productData.meeting_point || productData.meeting_point_description) {
                        <div class="PGBookedProduct-Section PGBookedProduct-Section--MeetingPoint">
                            <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-meeting_point' | locTranslate }}</h5>
                            <div class="PGBookedProduct-Selected PGBookedProduct-Selected--BFloatDeep border-bottom pb-3 mb-3 ">
                                @if (getMeetingPointImage(); as meetingPointImage) {
                                    <div class="my-2" [innerHTML]="meetingPointImage"></div>
                                }
                                @if (formatMeetingPointAddress(); as meetingPoint) {
                                    <div pdfgen="line">
                                        <i class="fa-regular fa-map-marker text-muted me-2"></i>
                                        <span>{{ meetingPoint }}</span>
                                    </div>
                                }
                                @if (formatMeetingPointDescription(); as meetingPointDescription) {
                                    <div pdfgen="line">{{ meetingPointDescription }}</div>
                                }
                            </div>
                        </div>
                    }
                }
                @if (selectedAccommodation != null) {
                    <div class="PGBookedProduct-Section">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-accommodation' | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected PGBookedProduct-Selected--BFloatDeep border-bottom pb-3 mb-3">
                            <app-pg-product-host-accommodation [accommodationData]="selectedAccommodation"></app-pg-product-host-accommodation>
                        </div>
                    </div>
                }
    
                @if (selectedTickets != null) {
                    <div class="PGBookedProduct-Section">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-tickets' + (isCumulativeBooking() ? '-cumulative' : productData.type == 'host' ? '-host' : '') | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected PGBookedProduct-Selected--BFloatDeep border-bottom pb-3 mb-3">
                            @if (productData.price_on_request) {
                                <div>
                                    @if (selectedTickets.fullQuantity > 0) {
                                        <div [innerHTML]="'pg-booking-product.tickets-price-on-request' | locTranslate:'quantity':selectedTickets.fullQuantity"></div>
                                    }
                                </div>
                            }
                            @else {
                                <div>
                                    <div pdfgen="line">
                                        @if (selectedTickets.fullQuantity > 0) {
                                            <div [innerHTML]="'pg-booking-product.tickets-full-price' + (productData.type == 'host' ? '-host' : '') | locTranslate:'price':formatPrice(selectedTickets.fullPrice, true):'quantity':selectedTickets.fullQuantity"></div>
                                        }
                                        @for (other of selectedTickets.otherTickets; track other) {
                                            @if (other.quantity > 0) {
                                                <div [innerHTML]="'pg-booking-product.tickets-other' + (productData.type == 'host' ? '-host' : '') | locTranslate:'label':formatTicketName(other.name):'price':formatPrice(other.price, true):'quantity':other.quantity"></div>
                                            }
                                        }
                                    </div>
                                    @if (productData.type != 'host') {
                                        <div pdfgen="line" [innerHTML]="'pg-booking-product.tickets-total' | locTranslate:'price':formatPrice(getSelectedTicketsTotal(), true)"></div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
    
                @if (surveyAnswers != null) {
                    <div class="PGBookedProduct-Section">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-survey' | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3">
                            <div>
                                @for (question of surveyAnswers.questions; track question) {
                                    <div  pdfgen="line"><b>{{formatQuestionText(question.text)}}</b></div>
                                    @if (question.type == 'boolean' && question.answer != null) {
                                        <div pdfgen="line">{{ 'pg-survey-editor.answer-boolean-' + question.answer  | locTranslate }}</div>
                                    }
                                    @if (question.type == 'string') {
                                        <div pdfgen="line">{{question.answer}}</div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                }
    
                @if (discountCode != null) {
                    <div class="PGBookedProduct-Section">
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3">
                            <div>
                                <span>{{ 'pg-booking-product.discount-code' | locTranslate }}</span>
                                <b class="float-end">{{discountCode}}</b>
                            </div>
                            @if (discountValue != null) {
                                <div>
                                    <span>{{ 'pg-booking-product.discount-applied' | locTranslate }}</span>
                                    <b class="float-end text-success">-{{discountValue}}%</b>
                                </div>
                                @if (selectedTickets != null) {
                                    <div>
                                        <span>{{ 'pg-booking-product.discount-total' | locTranslate }}</span>
                                        <b class="float-end">{{formatDiscountPrice()}}</b>
                                    </div>
                                }
                            }
                        </div>
                    </div>
                }
    
                @if (userEmail != null || userPhone != null) {
                    <div class="PGBookedProduct-Section">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-contact' | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3">
                            @if (userName != null) {
                                <div pdfgen="line">
                                    <span>{{ 'pg-booking-product.contact-name' | locTranslate }}</span>
                                    <b class="float-end">{{userName}}</b>
                                </div>
                            }
                            @if (userEmail != null) {
                                <div pdfgen="line">
                                    <span>{{ 'pg-booking-product.contact-email' | locTranslate }}</span>
                                    <b class="float-end">{{userEmail}}</b>
                                </div>
                            }
                            @if (userPhone != null) {
                                <div pdfgen="line">
                                    <span>{{ 'pg-booking-product.contact-phone' | locTranslate }}</span>
                                    <b class="float-end">{{userPhone}}</b>
                                </div>
                            }
                        </div>
                    </div>
                }
    
                @if (brokerCode != null) {
                    <div class="PGBookedProduct-Section">
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3">
                            <div>
                                <span>{{ 'pg-booking-product.broker-code' | locTranslate }}</span>
                                <b class="float-end">{{brokerCode}}</b>
                            </div>
                            <div>
                                <span>{{ 'pg-booking-product.broker-discount' | locTranslate }}</span>
                                <b class="float-end">{{productData.broker_discount}} %</b>
                            </div>
                            @if (selectedTickets != null) {
                                <div>
                                    <span>{{ 'pg-booking-product.broker-quota' | locTranslate }}</span>
                                    <b class="float-end">{{getBrokerQuota()}} {{getCurrencySymbol()}}</b>
                                </div>
                            }
                        </div>
                    </div>
                }
    
                @if (isOptioned) {
                    <div class="PGBookedProduct-Section PGBookedProduct-Section-Optioned">
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3">
                            <h5 class="m-0">
                                <i class="fa-regular fa-hourglass me-2"></i>{{ 'pg-booking-product.title-optioned' | locTranslate }}
                            </h5>
                        </div>
                    </div>
                }
    
                @if (paymentMethod != null) {
                    <div class="PGBookedProduct-Section PGBookedProduct-Section-PaymentMethod">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-payment-method' | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3">
                            @if (paymentMethod == 'sul_posto') {
                                <div pdfgen="line">
                                    <i class="fa-regular fa-map-marker text-muted me-1"></i>{{ 'pg-booking-product.payment-method-inloco' | locTranslate }}
                                </div>
                            }
                            @if (paymentMethod == 'bonifico') {
                                <div pdfgen="line">
                                    <i class="fa-regular fa-money-check-alt text-muted me-1"></i>{{ 'pg-booking-product.payment-method-bonifico' | locTranslate }}
                                    <div class="mt-2">
                                        <div pdfgen="line">
                                            <div>{{ 'pg-booking-product.payment-method-bonifico-todo-1' | locTranslate }}</div>
                                            <div>
                                                <span>IBAN</span>
                                                <b class="float-end">{{productData.bank_transfer_method != null ? productData.bank_transfer_method.iban : null}}</b>
                                            </div>
                                            <div>
                                                <span>SWIFT</span>
                                                <b class="float-end">{{productData.bank_transfer_method != null ? productData.bank_transfer_method.swift : null}}</b>
                                            </div>
                                        </div>
                                        <div pdfgen="line">
                                            <div>{{ 'pg-booking-product.payment-method-bonifico-todo-2' | locTranslate }}</div>
                                            <div>
                                                <b>{{getBonificoCausale(productData)}}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (paymentMethod == 'broker') {
                                <div pdfgen="line">
                                    <i class="fa-regular fa-receipt text-muted me-1"></i>{{ 'pg-booking-product.payment-method-broker' | locTranslate }}
                                </div>
                            }
                            @if (paymentMethod == 'online') {
                                <div pdfgen="line">
                                    <i class="fa-regular fa-credit-card text-muted me-1"></i>{{ 'pg-booking-product.payment-method-online' | locTranslate }}
                                </div>
                            }
                            @if (paymentMethod == 'pagopa') {
                                <div pdfgen="line">
                                    <i class="fa-regular fa-building-columns text-muted me-1"></i>{{ 'pg-booking-product.payment-method-pagopa' | locTranslate }}
                                </div>
                            }
                            @if (paymentMethod == 'gratis') {
                                <div pdfgen="line">
                                    <i class="fa-regular fa-gift text-muted me-1"></i>{{ 'pg-booking-product.payment-method-gratis' | locTranslate }}
                                </div>
                            }
                            @if (paymentMethod == 'price_on_request') {
                                <div pdfgen="line">
                                    <i class="fa-regular fa-phone text-muted me-1"></i>{{ 'pg-booking-product.payment-method-price_on_request' | locTranslate }}
                                </div>
                            }
                        </div>
                    </div>
                }
    
                @if (additionalInformations != null && additionalInformations != '') {
                    <div class="PGBookedProduct-Section">
                        <h5 class="mb-2" pdfgen="line" pdfgen-weight="bold">{{ 'pg-booking-product.title-additional-infos' | locTranslate }}</h5>
                        <div class="PGBookedProduct-Selected border-bottom pb-3 mb-3" pdfgen="line">
                            {{additionalInformations}}
                        </div>
                    </div>
                }
            </span>
    
            <div class="PGBookedProduct-Footer d-flex mb-3 justify-content-between align-items-center">
                <div class="text-muted">
                    @if (pid != null && pid != '') {
                        <span pdfgen="line">
                            PID: <span class="text-uppercase font-monospace">{{pid}}</span>
                        </span>
                    }
                </div>
                @if (compact != 'never') {
                    <div>
                        <button class="btn btn-link btn-sm p-0" (click)="compact = !compact">
                            @if (compact) {
                                <span>{{ 'pg-booking-product.show-more' | locTranslate }}</span>
                            }
                            @if (!compact) {
                                <span>{{ 'pg-booking-product.show-less' | locTranslate }}</span>
                            }
                        </button>
                    </div>
                }
            </div>
        </div>
        <div class="d-none" pdfgen="block">
            <div pdfgen="line">
                {{ 'pg-booking-product.footer' | locTranslate }} {{getWebsiteURLClean()}}
            </div>
        </div>
    }
</div>